// Sample Personnel Data
export const personnel = [
  {
    id: 1,
    name: 'John Doe',
    title: 'Senior Architect',
    email: 'john@firm.com',
    phone: '555-0100',
    hasResume: true,
    joinedDate: '6 months ago',
    role: 'Admin',
    avatar: 'JD',
  },
  {
    id: 2,
    name: 'Sarah Lee',
    title: 'Structural Engineer',
    email: 'sarah@firm.com',
    phone: '555-0101',
    hasResume: true,
    joinedDate: '2 months ago',
    role: 'Member',
    avatar: 'SL',
  },
  {
    id: 3,
    name: 'Mike Chen',
    title: 'Project Manager',
    email: 'mike@firm.com',
    phone: '555-0102',
    hasResume: true,
    joinedDate: '1 year ago',
    role: 'Member',
    avatar: 'MC',
  },
  {
    id: 4,
    name: 'Emily Davis',
    title: 'Interior Designer',
    email: 'emily@firm.com',
    phone: '555-0103',
    hasResume: true,
    joinedDate: '3 months ago',
    role: 'Member',
    avatar: 'ED',
  },
  {
    id: 5,
    name: 'Robert Kim',
    title: 'MEP Engineer',
    email: 'robert@firm.com',
    phone: '555-0104',
    hasResume: false,
    joinedDate: '5 months ago',
    role: 'Member',
    avatar: 'RK',
  },
]
// Sample Projects Data
export const projects = [
  {
    id: 1,
    name: 'Downtown Office Complex',
    client: 'ABC Corporation',
    location: 'Denver, CO',
    completedDate: 'Dec 2023',
    value: '$2.5M',
  },
  {
    id: 2,
    name: 'Medical Center Expansion',
    client: 'HealthCare Inc',
    location: 'Austin, TX',
    completedDate: 'Mar 2024',
    value: '$3.2M',
  },
  {
    id: 3,
    name: 'University Library',
    client: 'State University',
    location: 'Boulder, CO',
    completedDate: 'Jun 2024',
    value: '$5.2M',
  },
  {
    id: 4,
    name: 'Residential Tower',
    client: 'XYZ Developers',
    location: 'Seattle, WA',
    completedDate: 'Sep 2024',
    value: '$8.1M',
  },
  {
    id: 5,
    name: 'Airport Terminal',
    client: 'Airport Authority',
    location: 'Phoenix, AZ',
    completedDate: 'Dec 2024',
    value: '$12.5M',
  },
]
// Sample Pursuits Data
export const pursuits = [
  {
    id: 1,
    name: 'Downtown Office Complex',
    client: 'ABC Corp',
    value: '$2.5M',
    deadline: 'Dec 15, 2024',
    status: 'Active',
  },
  {
    id: 2,
    name: 'Medical Center Wing',
    client: 'HealthCare Inc',
    value: '$3.2M',
    deadline: 'Jan 30, 2025',
    status: 'Active',
  },
  {
    id: 3,
    name: 'City Hall Renovation',
    client: 'City Government',
    value: '$1.8M',
    deadline: 'Feb 10, 2025',
    status: 'Pending',
  },
  {
    id: 4,
    name: 'Bridge Replacement',
    client: 'State DOT',
    value: '$4.5M',
    deadline: 'Mar 1, 2025',
    status: 'Pending',
  },
  {
    id: 5,
    name: 'School Campus',
    client: 'School District',
    value: '$6.2M',
    deadline: 'Completed',
    status: 'Won',
  },
  {
    id: 6,
    name: 'Airport Terminal',
    client: 'Airport Authority',
    value: '$12.5M',
    deadline: 'Oct 15, 2024',
    status: 'Lost',
  },
]
// Sample Activity Feed Data
export const activityFeed = [
  {
    id: 1,
    user: 'Sarah',
    action: 'added new project',
    target: 'City Hall',
    time: '2 hours ago',
    icon: 'user',
  },
  {
    id: 2,
    user: 'John',
    action: 'uploaded',
    target: 'RFQ analysis',
    time: '4 hours ago',
    icon: 'file',
  },
  {
    id: 3,
    user: 'System',
    action: 'moved Pursuit',
    target: 'Medical Center to Active',
    time: 'Yesterday',
    icon: 'target',
  },
  {
    id: 4,
    user: 'Mike',
    action: 'commented on',
    target: 'Downtown Office proposal',
    time: '2 days ago',
    icon: 'message',
  },
]
// Sample Inbox Messages
export const inboxMessages = [
  {
    id: 1,
    title: 'Deadline Reminder',
    preview: 'Pursuit "Downtown Office" deadline is in 3 days.',
    sender: 'System',
    time: '2 hours ago',
    isRead: false,
    category: 'Deadlines',
  },
  {
    id: 2,
    title: 'Sarah mentioned you',
    preview: 'Can you review the proposal draft by tomorrow?',
    sender: 'Sarah Lee',
    time: '4 hours ago',
    isRead: false,
    category: 'Mentions',
  },
  {
    id: 3,
    title: 'Project updated',
    preview: 'Medical Center project details have been updated',
    sender: 'John Doe',
    time: '1 day ago',
    isRead: true,
    category: 'Team Activity',
  },
  {
    id: 4,
    title: 'New team member',
    preview: 'Emily Davis has joined your team',
    sender: 'System',
    time: '2 days ago',
    isRead: true,
    category: 'Team Activity',
  },
]
// Sample Assets
export const assets = [
  {
    id: 1,
    name: 'John Doe Resume',
    type: 'Resume',
    owner: 'John D.',
    size: '2.4 MB',
    dateAdded: '2d ago',
  },
  {
    id: 2,
    name: 'Sarah Lee Resume',
    type: 'Resume',
    owner: 'Sarah M.',
    size: '1.8 MB',
    dateAdded: '1w ago',
  },
  {
    id: 3,
    name: 'Downtown Office Renders',
    type: 'Project',
    owner: 'Office',
    size: '5.2 MB',
    dateAdded: '3w ago',
  },
  {
    id: 4,
    name: 'Mike Chen Resume',
    type: 'Resume',
    owner: 'Mike T.',
    size: '2.1 MB',
    dateAdded: '1m ago',
  },
  {
    id: 5,
    name: 'Medical Center Proposal',
    type: 'Project',
    owner: 'Medical',
    size: '3.5 MB',
    dateAdded: '2w ago',
  },
  {
    id: 6,
    name: 'Company Brochure 2024',
    type: 'Marketing',
    owner: 'Marketing',
    size: '4.7 MB',
    dateAdded: '1m ago',
  },
  {
    id: 7,
    name: 'Project Delivery Methods',
    type: 'Documents',
    owner: 'Admin',
    size: '1.2 MB',
    dateAdded: '2m ago',
  },
  {
    id: 8,
    name: 'Emily Davis Resume',
    type: 'Resume',
    owner: 'Emily D.',
    size: '1.9 MB',
    dateAdded: '2w ago',
  },
]
// Sample Pending Invitations
export const pendingInvitations = [
  {
    id: 1,
    email: 'mike@firm.com',
    invitedDate: '2 days ago',
  },
  {
    id: 2,
    email: 'jennifer@firm.com',
    invitedDate: '5 days ago',
  },
]
